// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://airpix-217611.uc.r.appspot.com',
  socket_endpoint: 'https://airpix-217611.uc.r.appspot.com'
};

//   apiUrl: 'https://safety-va-backend.herokuapp.com',
//   socket_endpoint: 'https://safety-va-backend.herokuapp.com'
//   apiUrl: 'http://localhost:4000',
//   socket_endpoint: 'http://localhost:4000'

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
